import { refreshUserProfile, upsertUserProfile } from '@/api/user-manager'
import { UpsertUserProfileBody } from '@/types'

export async function saveProfile(body: UpsertUserProfileBody) {
  await upsertUserProfile(body)
  return refreshUserProfile()
}
